import isPropValid from "@emotion/is-prop-valid";
import styled from "styled-components";
export const IconPositioningContainer = styled.span.withConfig({
    shouldForwardProp: isPropValid,
}) `
  line-height: inherit;
  display: flex;
  align-items: center;
  align-self: flex-start;
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSWNvblBvc2l0aW9uaW5nQ29udGFpbmVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvVGV4dFdpdGhJY29uTGF5b3V0L3N0eWxlZC9JY29uUG9zaXRpb25pbmdDb250YWluZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxXQUFXLE1BQU0sd0JBQXdCLENBQUM7QUFDakQsT0FBTyxNQUFNLE1BQU0sbUJBQW1CLENBQUM7QUFFdkMsTUFBTSxDQUFDLE1BQU0sd0JBQXdCLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxVQUFVLENBQUM7SUFDN0QsaUJBQWlCLEVBQUUsV0FBVztDQUMvQixDQUFDLENBQUE7Ozs7O0NBS0QsQ0FBQyJ9